/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowDown(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M205.65674,149.65723l-72,72a8.00063,8.00063,0,0,1-11.31348,0l-72-72A8.0001,8.0001,0,0,1,56,136h64V40a8,8,0,0,1,16,0v96h64a8.0001,8.0001,0,0,1,5.65674,13.65723Z" />
    </Svg>
  );
}

export default ArrowDown;
